function Lebanon({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1500)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M16 0C9.65664 0 4.17565 3.69156 1.58765 9.0435H30.4123C27.8244 3.69156 22.3433 0 16 0Z" fill="#D80027"/>
  <path d="M16 32C22.3433 32 27.8244 28.3085 30.4124 22.9565H1.58765C4.17565 28.3085 9.65664 32 16 32Z" fill="#D80027"/>
  <path d="M20.1739 18.7826L16 11.1304L11.826 18.7826H14.9565V20.8695H17.0435V18.7826H20.1739Z" fill="#6DA544"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Lebanon;
